import * as S from './styled'
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import { NumericFormat } from 'react-number-format';
/**
 * Components
*/
import LayoutWithList from '../../../LayoutModal/WithList';
import ActionButton from '../../../Button/ActionButton';
import Delete from '../../Delete';
import Update from '../Update';
/**
 * hooks
*/
import apiRequest from '../../../../hooks/apiRequest';
import { useMultipleModal } from '../../../../hooks/useMultipleModal';
import { useEffect, useState } from 'react';
/**
 * Icons 
*/
import { PencilSimple, Trash } from '@phosphor-icons/react';
/**
 * Interfaces
*/
import { ISensitivity, Inputs } from 'Interfaces/ISensitivity';

interface ICreate {
  isOpenModalBraind: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateSensitivity({
  isOpenModalBraind,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const tableHead = ["#", "Nome", "Porcentagem", "Ações"];
  const [data, setData] = useState<ISensitivity[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`sensitivity`);
      setData(response.data);
      console.log('sensibilidade: ', response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModalBraind) {
      fetchData();
    }
  }, []);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await apiRequest("sensitivity", "POST", data);
      if (response.status === 201) {
        alert("Sensibilidade criada com sucesso!");
        fetchData();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o grife.");
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModalBraind) {
    return (
      <LayoutWithList
        title="Registrar Sensibilidade"
        subTitle="Cadastre uma nova sensibilidade em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Sensibilidade
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe a sensibilidade"
                type="text"
                {...register("sensitivity", { required: true })}
              />
              {errors.sensitivity && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Porcentagem %
                <span>*</span>
              </S.Label>
              <Controller
                name="percentage"
                control={control}
                rules={{ required: "Campo obrigatório" }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="0,00 %"
                    suffix=" %"
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue);
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.percentage && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Sensibilidades Cadastradas</S.TitleList>

          <S.Table>
            <thead>
              <tr>
                {tableHead.map((val) => {
                  return <th>{val}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {data.map((val, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.sensitivity}</td>
                    <td>{val.percentage}%</td>
                    <td>
                      <S.ContentButton>
                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "update")}
                        >
                          <PencilSimple size={20} />
                        </S.ButtonIconTable>

                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "delete")}
                        >
                          <Trash size={20} color="red" />
                        </S.ButtonIconTable>
                      </S.ContentButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </S.Table>
        </S.Footer>

        <Update
          isOpenModalUpdate={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          updateList={fetchData}
        />

        <Delete
          updateList={fetchData}
          endpoint="sensitivity"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModal("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}